import { proxy } from 'valtio'
import { isMobile } from '../helpers/platform.ts'
import { resetProxy } from './utils.ts'

const initialState = {
    currentPage: 'map',
    myPositionColor: JSON.parse(localStorage.getItem('myMarker') || '"#000000"') as string,
    followPets: true,
    showSafeZones: true,
    showLoader: false,
    purchaseError: '',
    changePassword: false,
    isOnMobileDevice: isMobile(),
    menuOpen: false,
    findOpen: false,
    directionsVisible: false,
    navDirection: 'none' as 'forward' | 'back' | 'none',
}

export const controlState = proxy({ ...initialState })

export function resetControl() {
    resetProxy(controlState, {
        ...initialState,
        isOnMobileDevice: isMobile(),
    })
}

export default controlState
